import {RecordTableAction} from "../../../types/record-table-action.types";

export const relevantAction: Array<RecordTableAction> = [
  'DOWNLOAD_EXCEL', 'DOWNLOAD_OLD_FORMAT_EXCEL', 'UNBIND_BLOGGER',
  'UNBIND_CONTACT', 'DELETE_CONTACT', 'EDIT_BLOGGER',
  'UNBIND_BANK_DETAILS', 'DELETE_BANK_DETAILS', 'EDIT_PROFILES_BLOGGER',
  'UNBIND_ADVERTISEMENT_PACKAGE', 'ADD_ADVERTISEMENT_PACKAGE', 'RESIZE_COLUMN',
  'CREATE_PROFILE_BLOGGER', 'DELETE_PROFILE_BLOGGER', 'VIEW_BLOGGER_GROUPS',
  'UNBIND_CUSTOMER', 'UNBIND_PRODUCT_CARD', 'UPLOAD_EXCEL', 'PRICE_LEVEL_CONFIG_COPY',
  'RRC_LIMIT_COPY'
]
